import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

/**
 * Session Service - Handles all session management API calls
 */
class SessionService {
  /**
   * Get all sessions for a user
   * @param {string} userId - User ID
   * @returns {Promise} API response with sessions array
   */
  async getUserSessions(userId) {
    try {
      const response = await apiClient.get(
        getApiUrl(API_ENDPOINTS.SESSIONS.USER_SESSIONS(userId))
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get messages for a specific session
   * @param {string} sessionId - Session ID
   * @returns {Promise} API response with messages array
   */
  async getSessionMessages(sessionId) {
    try {
      const response = await apiClient.get(
        getApiUrl(API_ENDPOINTS.SESSIONS.MESSAGES(sessionId))
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get session info
   * @param {string} sessionId - Session ID
   * @returns {Promise} API response with session info
   */
  async getSessionInfo(sessionId) {
    try {
      const response = await apiClient.get(
        getApiUrl(API_ENDPOINTS.SESSIONS.SESSION_INFO(sessionId))
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete a session
   * @param {string} sessionId - Session ID to delete
   * @returns {Promise} API response
   */
  async deleteSession(sessionId) {
    try {
      const response = await apiClient.delete(
        getApiUrl(API_ENDPOINTS.SESSIONS.DELETE(sessionId))
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Clear session messages
   * @param {string} sessionId - Session ID
   * @returns {Promise} API response
   */
  async clearSession(sessionId) {
    try {
      const response = await apiClient.post(
        getApiUrl(API_ENDPOINTS.SESSIONS.CLEAR(sessionId)),
        {}
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const sessionService = new SessionService();
export default sessionService;

